<template>
  <date-picker
    v-model="date"
    range
    placeholder="Data Inicial  Data Final"
    format="DD MMM YYYY"
    :lang="lang"
    class="w-100"
    @clear="callClear"
  />
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { formatLocale } from '_utils';

export default {
  name: 'datepicker-interval',
  components: { DatePicker },
  data() {
    return {
      lang: {
        formatLocale,
        monthBeforeYear: false,
      },
    };
  },
  props: {
    dateTo: {
      required: true,
      default: null,
    },
    dateFrom: {
      required: true,
      default: null,
    },
    onClear: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    date: {
      get() {
        return [this.dateFrom, this.dateTo];
      },
      set(val) {
        if (val) {
          const [dateFrom, dateTo] = val;
          this.$emit('update:dateTo', dateTo);
          this.$emit('update:dateFrom', dateFrom);
        }
      },
    },
  },
  methods: {
    callClear() {
      this.onClear();
    },
  },
};
</script>

<style lang="scss">
.mx-datepicker-header {
  display: flex;
  justify-content: space-around;
  border: none;

  h6 {
    text-align: center;
    margin-bottom: 0.05rem;
    font-weight: 400;
  }
}

.mx-input {
  width: 100%;
  height: 100%;
  padding: 9.3px 7px;
}

.mx-input:hover {
  border: 1px solid #cccccc;
}

.mx-input:focus {
  border: 1px solid #213167;
}

.mx-calendar.mx-calendar {
  border-left: 1px solid #e8e8e8;
}

.mx-calendar {
  color: #5a6169 !important;
  padding: 20px 22px !important;
  min-width: 10rem;
  font-size: 1rem !important;
  font-weight: 300 !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol' !important;
  background-color: none;
  border: none;
  border-radius: none;
  box-shadow: none;
  border: 0px solid rgba(0, 0, 0, 0.15) !important;
  border-left: 1px solid #e8e8e8;
  width: 300px !important;
}
</style>
